import { useEffect } from "react";
import { useParams } from "react-router-dom";

import SubCompanyTable from "../companyEdit/SubCompanyTable";
import { useGetCompanyEx } from "../../api/CompaniesApi";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import SearchBar from "../SearchBar";
import { AddCompanyButton } from "../AddCompanyButton";
import { usePermissionValidator } from "../../api/UserPermissionValidators";

const SubCompanyListPage = () => {
  const { companies } = usePermissionValidator();
  const { companyId } = useParams();
  const {
    isLoading: loadingCompanyEx,
    data: companyEx,
    mutate: loadCompanyEx,
  } = useGetCompanyEx();

  useEffect(() => {
    if (!companyId) {
      return;
    }
    loadCompanyEx(companyId);
  }, [companyId, loadCompanyEx]);
  return (
    <>
      <div className="flex items-center">
        <div className="flex-1">
          <h1 className="text-xl font-bold">Sub Companies</h1>
        </div>
        <div className="flex-0 p-2">
          {loadingCompanyEx ? (
            <LoadingSpinner />
          ) : (
            companyEx?.settings["CAN_CREATE_COMPANY"]?.toLowerCase() ===
              "true" && (
              <div className="flex gap-4">
                <SearchBar placeholder="Search" />
                {companies.canAddSubcompany && (
                  <AddCompanyButton
                    companyType={"Sub Company"}
                    usePlus={true}
                  />
                )}
              </div>
            )
          )}
        </div>
      </div>
      <SubCompanyTable inputUUID={companyId} />
    </>
  );
};

export default SubCompanyListPage;
